<template>
	<div class="page-container">
		<div class="back_left" @click="$router.go(-1)" />
		<div class="headers">
			<h1 style="margin-top: 10px;">拉新钱包提现</h1>
		</div>
		<div class="imggw">
			<img width="150px" src="../images/user/11wh0-eeva3.png" alt="">
		</div>
		<div class="form-wrapper">
			<form class="card-form">
				<div class="form-title">提现</div>

				<div class="form-group">
					<label>当前余额</label>
					<input v-model="invite.invite_money" type="number" disabled>
				</div>
				
				<div class="form-group">
					<label>支付密码</label>
					<input v-model="paypwd" type="password" required placeholder="请输入支付密码">
				</div>

				<div class="form-group-withdraw">
					<label>提现金额</label>
					<div>
						<span>￥</span>
						<input v-model="money" type="number" required placeholder="请输入提现金额">
					</div>
				</div>

				<div class="hgs" @click="changShow">
					<div class="cardhgs" v-if="bankId">
						<div>
							<img class="lefs" :src="require('../images/user/recharge'+hgInfo.type+'.png')" alt="">
							<div><span>{{ hgInfo.area }}</span>{{ hgInfo.account }}</div>
						</div>
						<div style="color: #ffd08e; height: 30px; line-height: 30px; text-align: center">更换银行卡</div>
					</div>
					<div v-else style="color: #ffd08e; height: 30px; line-height: 30px; text-align: center">请选择银行卡</div>
				</div>
			</form>
		</div>

		<button class="confirm-btn" @click="handleSubmit">立即提现</button>

		<!-- 弹出层  -->
		<van-popup v-model="show" position="bottom" v-show="show" :style="{ height: '70%', background: '#f8f8f8' }"
			class="card">
			<div class="poptit">请选择银行卡</div>

			<div class="lis" v-for="i in data.bank" :key="i.index" @click="changApiType(i)">
				<img class="lefs" :src="require('../images/user/recharge'+i.type+'.png')" alt="">
				<div class="cest">
					<p class="type">
						{{ i.area }}
					</p>
					<p class="type">
						{{ i.account }}
					</p>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	export default {
		data() {
			return {
				money: null,
				paypwd: null,
				show: false,
				data: {},
				invite: {},
				hgInfo: {},
				bankId: null,
			}
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.banksum();
			this.getInvite();
		},
		methods: {
			changShow() {
				this.show = !this.show;
			},
			banksum() {
				Fetch('/user/my_bank').then(r => {
					this.data = r.data;
				})
			},
			getInvite() {
				Fetch('/user/invite').then(r => {
					this.invite = r.data;
				})
			},
			handleSubmit() {
				const money = this.money;
				const passwd = this.paypwd;
				const bank_id = this.bankId;
				const wallet = "拉新钱包";
				if (!money) {
					this.$toast({
						className: "toastName",
						message: '请输入需要提现的金额',
					});
					return false;
				}
				if (!bank_id) {
					this.$toast({
						className: "toastName",
						message: '请选择银行卡',
					});
					return false;
				}
				if (!passwd) {
					this.$toast({
						className: "toastName",
						message: '请输入支付密码',
					});
					return false;
				}
				if (!money > this.invite.invite_money) {
					this.$toast({
						className: "toastName",
						message: '提现金额超过当前余额',
					});
					return false;
				}
				const message=`确认将￥${money}提现 ${this.hgInfo.bank} 到卡(****${this.hgInfo.account.slice(-4)})？\n预计7个工作日内到账`
				this.$dialog.confirm({
					title:'确认提现',
					message,
				}).then(res=>{
					Fetch('/user/cost_apply', {
						money,
						passwd,
						bank_id,
						wallet
						}).then(res => {

						console.log(res);

						this.$toast({
							className: "toastName",
							// message: r.info,
							message: res.info['zh_cn'] ? res.info['zh_cn'] : res.info,
						});
						setTimeout(() => {
							this.$router.go(-1);
						}, 1500);
					})
				});
			},
			changApiType(e) {
				this.hgInfo = e;
				console.log(e);
				this.bankId = e.id;
				this.password = null;
				this.amount = null;
				this.show = false;
			},
		}
	}
</script>

<style lang="less" scoped>
	.page-container {
		height: 700px;
		background: url(../images/user/redimg.jpg) no-repeat center;
		background-size: 112% 102%;
		position: relative;
		// height: 100vh;
	}

	.headers {
		color: #ffd08e;
		font-size: 24px;
		position: absolute;
		top: 10%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 100%;
		text-align: center;
	}

	.form-wrapper {
		position: absolute;
		top: 61%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 90%;
		height: 280px;
		max-width: 500px;
		background: #fff;
		padding: 0 20px 20px;
		border-radius: 8px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	}

	.card-form h2 {
		text-align: center;
		margin-bottom: 20px;
	}

	.form-title {
		width: 200px;
		margin: 0 auto 10px;
		background: #d7000f;
		color: #fff;
		border-radius: 0 0 12px 12px;
		padding: 8px 0;
		font-size: 16px;
		text-align: center;
		margin-bottom: 18px;
		font-weight: bold;
	}

	.form-group {
		margin-bottom: 15px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid #ddd;
	}

	.form-group-withdraw {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 8px;
	}

	.form-group-withdraw label {
		font-size: 14px;
		font-weight: 600;
	}

	.form-group-withdraw span {
		font-size: 20px;
	}

	.form-group-withdraw div {
		display: flex;
		align-items: center;
	}

	.form-group-withdraw input {
		font-size: 15px;
	}

	label {
		display: block;
		// margin-bottom: 8px;
	}

	input {
		width: 70%;
		padding: 10px;
		// border: 1px solid #ddd;
		// border-radius: 4px;
	}

	.preview img {
		max-width: 100%;
		max-height: 200px;
		margin-top: 10px;
	}

	.confirm-btn {
		position: absolute;
		bottom: 55px;
		width: 90%;
		max-width: 500px;
		left: 50%;
		transform: translateX(-50%);
		padding: 12px 40px;
		background: #ffdf9a;
		color: red;
		border: none;
		border-radius: 4px;
		font-size: 18px;
		font-weight: bold;
		cursor: pointer;
	}

	.add-card {
		display: block;
		width: 100%;
		height: 150px;
		line-height: 150px;
		background: #fff0e0;
		color: #d7000f;
		border: 1px dashed #d7000f;
		border-radius: 6px;
		font-size: 15px;
		text-align: center;
		margin-bottom: 12px;
		cursor: pointer;
	}

	.tip {
		color: #d7000f;
		font-size: 12px;
		text-align: center;
		margin-top: 8px;
		margin-bottom: 10px;
	}

	.imggw {
		position: absolute;
		top: 18%;
		left: 50%;
		transform: translateX(-50%);
	}

	.card .lis {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 90%;
		margin: 0 auto;
		margin-top: 20px;
		box-sizing: border-box;
		padding: 10px 25px;
		min-height: 80px;
		border-radius: 10px;
		position: relative;
		border-radius: 0.16rem;
		background-color: #f8f9ff;
		-webkit-box-shadow: 0 0.04rem 0.2rem rgb(199 212 255 / 42%);
		box-shadow: 0 0.04rem 0.2rem rgb(199 212 255 / 42%);
		border: 0.02rem solid #fff;
	}

	.card .lis .lefs {
		width: 1.5rem;
	}

	.card .lis .cest {
		flex: 1;
		margin: 0 20px;
	}

	.card .lis .cest .type {
		font-size: 0.4rem;
		font-weight: 700;
		color: #98a8c5;
		margin-top: 6px;
	}

	.card .lis .cest .num {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 6px;
		color: #98a8c5;
	}

	.card .lis .cest .num span {
		font-size: 0.6rem;
	}

	.card .lis .rigss {
		position: absolute;
		top: 10px;
		right: 10px;
		width: 0.6rem;
	}

	.page-container .van-popup {
		border-radius: 15px 15px 0 0;
	}

	.card .poptit {
		display: flex;
		align-items: center;
	}

	.poptit {
		height: 1.4rem;
		font-size: .4rem;
		justify-content: center;
		background: #fff;
		position: sticky;
		top: 0;
		z-index: 22;
	}

	.cardhgs {
		color: #cf866b;
		font-size: .23rem;
		height: 1.2rem;
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.cardhgs img {
		width: .8rem;
	}

	.cardhgs span {
		display: inline-block;
		margin: 0 6px;
	}

	.cardhgs div {
		font-size: 13px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>